import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import NotFound from "@/components/errorComponents/404NotFound.vue";
import ServerError from "@/components/errorComponents/500InternalServerError.vue";
import NetworkErr from "@/components/errorComponents/NetworkError.vue";
import store from "@/store";
import VueCookies from "vue-cookies";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    redirect: { name: "dashboard" },
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ "@/views/MainViews/DashboardView.vue"
          ),
        meta: { requiresAuth: true, preLoading: true },
      },
      {
        path: "products",
        name: "products",
        component: () =>
          import(
            /* webpackChunkName: "products" */ "@/views/MainViews/ProductView.vue"
          ),
        redirect: { name: "productsList" },
        children: [
          {
            path: "factor",
            name: "createFactor",
            component: () =>
              import(
                /* webpackChunkNmae: "createFactor" */ "@/views/MainViews/ProductsViews/CreateFactorView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "list",
            name: "productsList",
            component: () =>
              import(
                /* webpackChunkNmae: "productsList" */ "@/views/MainViews/ProductsViews/ProductsListView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "product-detail/:id",
            name: "productDetail",
            component: () =>
              import(
                /* webpackChunkName: "productDetail" */ "@/views/MainViews/ProductsViews/ProductDetailView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "manage-inventory",
            name: "manageInventory",
            component: () =>
              import(
                /* webpackChunkName: "manageInventory" */ "@/views/MainViews/ProductsViews/ManageInventoryView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
        ],
      },
      {
        path: "reports",
        name: "reports",
        component: () =>
          import(
            /* webpackChunkName: "reports" */ "@/views/MainViews/ReportsView.vue"
          ),
        redirect: { name: "factorsList" },
        children: [
          {
            path: "factors",
            name: "factorsList",
            component: () =>
              import(
                /* webpackChunkName: "factorsList" */ "@/views/MainViews/ReportsListViews/FactorsListView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "factors/detail/:id",
            name: "factorDetail",
            component: () =>
              import(
                /* webpackChunkName: "factorDetail" */ "@/views/MainViews/ReportsListViews/FactorDetailView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "requests",
            name: "requestsList",
            component: () =>
              import(
                /* webpackChunkName: "requestsList" */ "@/views/MainViews/ReportsListViews/RequestsListView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "detail/:id",
            name: "requestDetail",
            component: () =>
              import(
                /* webpackChunkName: "requestDetail" */ "@/views/MainViews/ReportsListViews/RequestDetailView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "defectives",
            name: "defectives",
            component: () =>
              import(
                /* webpackChunkName: "requestsList" */ "@/views/MainViews/ReportsListViews/DefectivesView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "cycle",
            name: "inventoryCycle",
            component: () =>
              import(
                /* webpackChunkName: "requestDetail" */ "@/views/MainViews/ReportsListViews/InventoryCycleView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
        ],
      },
      {
        path: "requests",
        name: "requests",
        component: () =>
          import(
            /* webpackChunkName: "requests" */ "@/views/MainViews/RequestsView.vue"
          ),
        redirect: { name: "myRequests" },
        children: [
          {
            path: "product",
            name: "requestProduct",
            component: () =>
              import(
                /* webpackChunkName: "requestProduct" */ "@/views/MainViews/RequestsViews/RequestProductView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "my-requests",
            name: "myRequests",
            component: () =>
              import(
                /* webpackChunkName: "myRequests" */ "@/views/MainViews/RequestsViews/MyRequestsView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "detail/:id",
            name: "myRequestDetail",
            component: () =>
              import(
                /* webpackChunkName: "requestDetail" */ "@/views/MainViews/RequestsViews/MyRequestDetailView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "employees",
            name: "employeesRequest",
            component: () =>
              import(
                /* webpackChunkName: "requestDetail" */ "@/views/MainViews/RequestsViews/EmployeesRequestView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "employees/:personal_id",
            name: "oneEmployeeRequest",
            component: () =>
              import(
                /* webpackChunkName: "requestDetail" */ "@/views/MainViews/RequestsViews/OneEmployeeRequestView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/MainViews/LoginView.vue"),
    meta: { requiresAuth: false, preLoading: false },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: NotFound,
    meta: { requiresAuth: false, preLoading: false },
  },
  {
    path: "/:pathMatch(.*)*/500",
    name: "500",
    component: ServerError,
    meta: { requiresAuth: false, preLoading: false },
  },
  {
    path: "/:pathMatch(.*)*/network-err",
    name: "NetworkErr",
    component: NetworkErr,
    meta: { requiresAuth: false, preLoading: false },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  window.scrollTo(0, 0);
  let authenticated = store.getters.getIsAuthenticated;
  if (VueCookies.isKey("__INVENTORY-REFRESH-TOKEN") && !authenticated) {
    store.commit("setIsAuthenticated");
    authenticated = true;
  }
  if (localStorage.getItem("dark-mode") == "true") {
    store.commit("setDarkMode", true);
  }
  let inventoryList = store.getters.getInventoryList;
  if (!authenticated && to.meta.requiresAuth) {
    router.push({ name: "login" });
  }
  else if (authenticated && inventoryList.length == 0) {
    await store.dispatch("getInventoryListFromApi");
  }
  if (to.meta.preLoading) {
    store.commit("setLoading", true);
  }
  let inventory = localStorage.getItem("inventory");
  if (inventory && inventoryList.some((item) => item.id == inventory)) {
    store.commit("setInventory", inventory);
  }
});

router.afterEach((to) => {
  window.scrollTo(0, 0);
  if (to.meta.preLoading) {
    store.commit("setLoading", false);
  }
});
export default router;
